import PropTypes from 'prop-types';

export const OEScreenshotControllerConfigDecl = PropTypes.shape({
    enabled: PropTypes.bool,
    showHelpBtn: PropTypes.bool,
    showUsageRightsBtn: PropTypes.bool,
    attributionOptional: PropTypes.bool,
    copyToClipboardOption: PropTypes.bool,
    attribution: PropTypes.shape({
        text: PropTypes.string,
        textID: PropTypes.string,
        imageURL: PropTypes.string,
        color: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({x: PropTypes.number, y: PropTypes.number, z: PropTypes.number, w: PropTypes.number})
        ]),
        font: PropTypes.shape({
            weight: PropTypes.number,
            size: PropTypes.number,
            name: PropTypes.string
        }),
        alignment: PropTypes.oneOf(['top-left', 'top-right', 'bottom-left', 'bottom-right']),
        padding: PropTypes.number
    })
});

export const OEScreenshotControllerConfigFactory = {
    buildStdConfig()    {
        return {
            enabled: true,
            showHelpBtn: true,
            showUsageRightsBtn: false,
            attributionOptional: true,
            copyToClipboardOption: true,
            attribution: {
                textID: 'screenshot_attribution'
            }
        };
    }
};